import React, { useState } from 'react';
import { Input, InputNumber } from 'antd';
import { useDispatch } from 'react-redux';

import { DevClusterAdmin, patchCluster } from 'state';
import { usePatchBuffer } from '../hooks';
import { Field, Section, LockedRow } from './inspectorBits';

type Props = { cluster: DevClusterAdmin; planCode: string; editable: boolean };

const ClusterInspector: React.FC<Props> = ({ cluster, planCode, editable }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(cluster.name);
  const { push } = usePatchBuffer<{ name: string }>((p) =>
    dispatch(patchCluster({ id: cluster.id, plan: planCode, ...p }))
  );
  const patch = (p: Record<string, unknown>) =>
    dispatch(patchCluster({ id: cluster.id, plan: planCode, ...p }));

  return (
    <div className="devadmin-insp">
      <div className="devadmin-insp__head">
        <div>
          <div className="devadmin-insp__kind">Cluster</div>
          <div className="devadmin-insp__title">{name}</div>
        </div>
      </div>

      <Section title="Cluster">
        <Field
          label="Name"
          info="The cluster's name, shown as the subtitle on a node's detail panel when the node belongs to this cluster. Display only."
        >
          <Input
            value={name}
            disabled={!editable}
            onChange={(e) => {
              setName(e.target.value);
              push({ name: e.target.value });
            }}
          />
        </Field>
        <Field
          label="Order"
          info="Currently unused by the trainee renderer (nodes sort by cluster code, not by this). Kept for future use."
        >
          <InputNumber
            value={cluster.order}
            disabled={!editable}
            onChange={(v) => v != null && patch({ order: v })}
          />
        </Field>
      </Section>

      <LockedRow
        label="Cluster code"
        value={cluster.code}
        why="The cluster's letter (A–E). Each node references its cluster by this code (its 'group'), so it's kept stable and not free-edited here."
      />
    </div>
  );
};

export default ClusterInspector;
